// Mock data for Blue Bird Logistics website

export const companyInfo = {
  name: "Blue Bird",
  tagline: "Complete Logistics Solution",
  email: "info@bbcs.express",
  phone: "+91 9573912643",
  address: "Room no:-265, 2nd Floor, 'C' Block, Chenoy Trade Center, Parklane, Secunderabad.",
  pincode: "500003"
};

export const stats = [
  { value: "27+", label: "Warehouses Across India" },
  { value: "19+", label: "States Covered" },
  { value: "67,000+", label: "Domestic Shipments" },
  { value: "80+", label: "Trains Cargo" }
];

export const services = [
  {
    id: 1,
    category: "Warehousing",
    title: "Multi-Client Warehousing",
    description: "State-of-the-art multi-client warehousing facilities across 27+ locations in India. Cost-effective, flexible storage solutions with advanced inventory management systems.",
    features: ["Real-time inventory tracking", "Climate-controlled storage", "24/7 security surveillance", "Flexible storage options"]
  },
  {
    id: 2,
    category: "Warehousing",
    title: "Dedicated Warehousing",
    description: "Customized dedicated warehouse solutions tailored to your specific business needs. Complete control over your storage infrastructure with dedicated resources.",
    features: ["Customized layouts", "Dedicated staff", "Advanced WMS integration", "Scalable infrastructure"]
  },
  {
    id: 3,
    category: "Warehousing",
    title: "In-house Inventory Management",
    description: "Comprehensive inventory management services with cutting-edge technology for real-time tracking, optimized stock levels, and seamless operations.",
    features: ["Automated tracking systems", "Stock optimization", "Regular audits", "Performance analytics"]
  },
  {
    id: 4,
    category: "Logistics",
    title: "Rail Logistics",
    description: "Efficient and cost-effective rail logistics solutions across India. Handle 80+ train cargo operations monthly with complete tracking and reliability.",
    features: ["Pan-India coverage", "Container management", "Door-to-door delivery", "Competitive pricing"]
  },
  {
    id: 5,
    category: "Logistics",
    title: "Full Truck / Part Loads",
    description: "Flexible road transportation solutions for full truckload (FTL) and less-than-truckload (LTL) shipments with guaranteed delivery timelines.",
    features: ["GPS-enabled tracking", "Flexible scheduling", "Multi-modal options", "Insurance coverage"]
  },
  {
    id: 6,
    category: "Logistics",
    title: "Air Freight",
    description: "Swift and reliable air freight services for time-sensitive cargo. Connect to major airports across India with priority handling and express delivery.",
    features: ["Express delivery", "Priority handling", "Customs clearance", "Global network"]
  },
  {
    id: 7,
    category: "SCM Consultancy",
    title: "HNS & ETAS Study",
    description: "Comprehensive Hub & Spoke Network and Estimated Time of Arrival studies to optimize your supply chain network design and efficiency.",
    features: ["Network optimization", "Cost analysis", "Performance metrics", "Strategic recommendations"]
  },
  {
    id: 8,
    category: "SCM Consultancy",
    title: "Logistics Cost Analysis",
    description: "In-depth logistics cost analysis to identify savings opportunities, optimize routes, and improve overall supply chain profitability.",
    features: ["Cost breakdown analysis", "Benchmarking", "ROI assessment", "Optimization strategies"]
  },
  {
    id: 9,
    category: "SCM Consultancy",
    title: "Logistics Network Design",
    description: "Strategic logistics network design services to create efficient, scalable, and cost-effective distribution networks aligned with your business goals.",
    features: ["Network modeling", "Scenario planning", "Technology integration", "Implementation support"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "Manufacturing Ltd.",
    role: "Supply Chain Director",
    content: "Blue Bird transformed our logistics operations. Their integrated approach reduced our costs by 25% while improving delivery times.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    company: "Retail Corp",
    role: "Operations Manager",
    content: "The warehousing solutions provided by Blue Bird are exceptional. Real-time tracking and professional management have been game-changers.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    company: "FMCG Industries",
    role: "Logistics Head",
    content: "Outstanding service! Their rail logistics expertise helped us scale operations across India efficiently and cost-effectively.",
    rating: 5
  }
];

export const aboutContent = {
  vision: "To become India's most trusted and innovative logistics partner, transforming supply chain complexity into competitive advantage.",
  mission: "Delivering integrated logistics excellence through cutting-edge technology, extensive infrastructure, and unwavering commitment to customer success.",
  founder: "Shri Ashok Kumar Tiwari",
  story: "India's supply chain is complex. Fragmented. Full of friction. Blue Bird was built to fix that. We are a full-spectrum logistics partner for medium and large enterprises across India — combining Rail Logistics, Road & Domestic Transportation, Warehousing, and Supply Chain Consulting under one powerful roof. No juggling multiple vendors. No communication gaps. No surprises. Just one partner who takes full ownership of your supply chain — end to end."
};

export const clientLogos = [
  "Client Logo 1",
  "Client Logo 2",
  "Client Logo 3",
  "Client Logo 4",
  "Client Logo 5",
  "Client Logo 6"
];
